import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {createSetInspectionTypesDataAction} from "../../../actions/dataActions";
import { getDataFresh, getInspectionTypesData } from "../../../state/selectors";
import Spinner from "react-spinner-material";
import { Box, Pagination, Table, Title } from "@allxsmith/bestax-bulma";
import { useInspectionTypeData } from "../../../hooks/useInspectionTypeData";
import NewInspectionType from "./NewInspectionType";
import InspectionTypeRow from "./InspectionTypeRow";
import PaginationWrapper from "../../Utils/PaginationWrapper";

function InspectionTypeView(props) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const dataFresh = useSelector(getDataFresh);

  const complete = useInspectionTypeData({ page }, dataFresh);

  const onInspectionTypeUpdate = (index, newInspectionType) => {
    let newResults = [...data.results];
    let newState = {...data, results: newResults};
    newState.results[index] = newInspectionType;
    dispatch(createSetInspectionTypesDataAction(newState));
  };

  const data = useSelector(getInspectionTypesData);

  if (!complete) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  return (
    <div>
      <NewInspectionType />
      <Box>
          <details>
              <summary><Title>Inspection Type</Title></summary>
          <Table>
            <thead>
              <tr>
                <th>Inspection Type</th>
                <th>Reminder (days before expiry)</th>
                <th>Warning (days before expiry)</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {data.results.map((value, index) => (
                <InspectionTypeRow
                  key={value.id}
                  inspectionTypeData={value}
                  index={index}
                  endpoint={props.endpoint}
                  onInspectionTypeUpdate={onInspectionTypeUpdate}
                />
              ))}
            </tbody>
          </Table>
          <PaginationWrapper
            setPage={setPage}
            page={page}
            dataCount={Math.ceil(data.count / 25)}
          />
          </details>
      </Box>
    </div>
  );
}

export default InspectionTypeView;
